import _ from 'lodash'
import {uuid} from '../../../utils'
import {BotMessage, Button, Carousel, Menu, Slide } from '../../types'
import { createQuickReply, createSlide, splitMessages} from './helpers'

const PARAMS_DELIMITER = '::db_chat_params::'

export default class AdapterMotion {
  constructor(config) {
    this.apiKey = config.apiKey
    this.botId = config.botId
    this.sessionId = uuid()
  }

  // returns BotResponse
  getBotResponse = async (question) => {
    let motionAnswer = await this._fetchAnswer(question)

    return transformMsg(motionAnswer)
  };

  resetSession = () => {
    this.sessionId = uuid()
  };


  _fetchAnswer(question) {
    // prevent response caching to avoid endless loops on immediately fetchNext
    return fetch(
      `https://api.motion.ai/messageBot?bot=${this.botId}&msg=${question}&key=${this.apiKey}&session=${this.sessionId}`,
      {headers: { 'pragma': 'no-cache', 'cache-control': 'no-cache' }}
    )
      .then(response => response.json())
      .then(json => {
        if (json.code !== 200) {
          throw new Error(json.err)
        } else {
          return json
        }
      })
  }
}


function transformMsg(resp) {
  let result = new BotMessage()

  let {textAnswer, params} = parseDbChatParams(resp.botResponse)

  // MESSAGES
  // split by ::next:: or ::next-xxxx::
  result.messages = splitMessages(textAnswer)

  // QUICK REPLIES
  result.quickReplies = resp.quickReplies.map(createQuickReply)

  // CAROUSEL
  let slides = _.get(params, 'carousel.slides', []).map( s => new Slide(s))
  // append Motion Ai cards
  slides = slides.concat(resp.cards.map(createSlide))
  result.carousel = !_.isEmpty(slides) && new Carousel(slides)

  // FETCH NEXT
  result.fetchNext = resp.immediatelyGoToNext

  // MENU
  if (params.menu) {
    result.menu = new Menu()
    result.menu.buttons = _.map(params.menu.buttons, b => new Button(b))
  }

  // FORCE REPLY
  if (_.has(params, 'config_msg_user.force_reply')) {
    result.forceReply = params.config_msg_user.force_reply
  }

  // THEME
  if (_.has(params, 'theme')) {
    result.theme = params.theme
  }

  return result
}


function parseDbChatParams(botResponse) {
  let [textAnswer, paramsText] = botResponse.split(PARAMS_DELIMITER)
  let result = {textAnswer, params: {}}

  if (paramsText) {
    let toParse = paramsText.replace(/!\[/g, '{').replace(/\]!/g,'}')
    try {
      result.params = JSON.parse(toParse)
      // console.log(result.params);
    } catch(err) {
      console.log('invalid custom parameters ', err.message)
      console.log(`original: ${paramsText}\ntransformed: ${toParse}`)
      debugger
    }
  }

  return result
}


// WEBPACK FOOTER //
// ./src/App/services/adapters/motion/index.js